const BusinessLoanHistory = () => (
  <h2>Business Loan History</h2>
);

export default BusinessLoanHistory;
